/**
 * Development Credentials Configuration
 *
 * IMPORTANT: These are only used for development/testing purposes.
 * In production, these should be empty strings.
 * Never commit actual credentials to version control.
 */

const isDevelopment = import.meta.env.DEV;

export const DEV_CREDENTIALS = {
  admin: {
    email: isDevelopment ? import.meta.env.VITE_DEV_ADMIN_EMAIL || '' : '',
    password: isDevelopment
      ? import.meta.env.VITE_DEV_ADMIN_PASSWORD || ''
      : '',
  },
  client: {
    TIN: isDevelopment ? import.meta.env.VITE_DEV_CLIENT_TIN || '' : '',
    contractId: isDevelopment
      ? import.meta.env.VITE_DEV_CLIENT_CONTRACT || ''
      : '',
  },
};

// Helper to check if dev credentials are configured
export const hasDevCredentials = () => {
  return (
    isDevelopment &&
    ((DEV_CREDENTIALS.admin.email && DEV_CREDENTIALS.admin.password) ||
      (DEV_CREDENTIALS.client.TIN && DEV_CREDENTIALS.client.contractId))
  );
};

// Log warning if using dev credentials
if (hasDevCredentials()) {
  console.warn(
    '⚠️ Using development credentials from .env file. ' +
      'This should NEVER happen in production!',
  );
}
